import styled from 'styled-components'
import FolderTree from '../FolderTree/FolderTree'
import ListView from '../../listView/ListView'
import MobileFolderNav from '../MobileFolderNav/MobileFolderNav'
import useScreenSize from '../../../hooks/useScreenSize'
import { ResizeHandle, PanelGroup, Panel } from '../../resizable/Resizable'

const BrowserWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 5.5rem);
`

const TreePanel = styled.div`
  border-right: 1px solid ${({ theme }) => theme.border?.default || '#e5e7eb'};
  max-height: calc(100vh - 4rem);
  overflow-y: auto;
`

const ListWrapper = styled.div`
  padding-left: 0.5rem;
`

const DocumentBrowser = () => {
  const { isMobile } = useScreenSize()

  if (isMobile) {
    return (
      <>
        <MobileFolderNav />
        <ListView type="documentList" options={{ viewFilters: true }} />
      </>
    )
  }

  return (
    <BrowserWrapper>
      <PanelGroup direction='horizontal'>
        <Panel defaultSize="22%" minSize="15%" maxSize="40%">
          <TreePanel>
            <FolderTree />
          </TreePanel>
        </Panel>
        <ResizeHandle />
        <Panel>
          <ListWrapper>
            <ListView type="documentList" options={{ viewFilters: true }} />
          </ListWrapper>
        </Panel>
      </PanelGroup>
    </BrowserWrapper>
  )
}

export default DocumentBrowser
